import React from 'react';
import Reveal from './Reveal';
import { processSteps, routeHref } from '../data/siteData';

const ExportProcess = () => {
  return (
    <section id="process" className="section-rule bg-white py-16 lg:py-28">
      <div className="container-custom">
        <div className="grid gap-12 lg:grid-cols-[0.92fr_1.08fr] lg:gap-16">
          <Reveal>
            <div className="process-story lg:sticky lg:top-32">
              <p className="eyebrow-pill mb-5">Coconut process</p>
              <h2 className="section-title mb-5 max-w-xl">
                From selected farms to buyer delivery support.
              </h2>
              <p className="section-subtitle max-w-xl">
                A refined coconut export journey built around sourcing discipline, careful grading, practical packaging, organized documentation, and clear shipment coordination.
              </p>

              <div className="process-visual mt-8">
                <img
                  src="/media/harvest-image.jpg"
                  alt="Coconut sorting and farm selection"
                  className="process-visual-image"
                />
                <div className="process-visual-panel">
                  <span className="process-visual-kicker">Controlled trade flow</span>
                  <h3>Source. Prepare. Ship.</h3>
                  <p>Every stage gives international buyers a clearer view of product movement and readiness.</p>
                </div>
              </div>
            </div>
          </Reveal>

          <div className="process-timeline" aria-label="Coconut export process timeline">
            {processSteps.map(({ number, title, description }, index) => (
              <Reveal key={title} delay={index * 70}>
                <article className="process-step">
                  <span className="process-step-number">{number}</span>
                  <div className="process-step-marker" aria-hidden="true"></div>
                  <div className="process-step-copy">
                    <p className="process-step-phase">Stage {index + 1}</p>
                    <h3>{title}</h3>
                    <p>{description}</p>
                  </div>
                </article>
              </Reveal>
            ))}

            <Reveal delay={processSteps.length * 70}>
              <div className="process-finish">
                <span className="process-finish-dot" aria-hidden="true"></span>
                <div>
                  <p className="process-step-phase">Ready for buyer review</p>
                  <h3>Shipment clarity from first inquiry to final handover.</h3>
                  <a className="text-link mt-5" href={routeHref('/quality')}>Review quality standards</a>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExportProcess;
